import type { Source } from '@/types/source-types';
import type { CheckedState } from '@radix-ui/react-checkbox';

export interface VisibleSelectionInfo {
  visibleCount: number;
  selectedVisibleCount: number;
  allSelected: boolean;
  partiallySelected: boolean;
}

export const toggleFileSelection = (
  prev: Set<string>,
  filename: string,
  selected: boolean,
): Set<string> => {
  const next = new Set(prev);
  if (selected) {
    next.add(filename);
  } else {
    next.delete(filename);
  }
  return next;
};

export const toggleSelectAllVisible = (
  prev: Set<string>,
  filteredSources: Source[],
  selected: boolean,
): Set<string> => {
  const next = new Set(prev);
  filteredSources.forEach((source) => {
    if (selected) {
      next.add(source.filename);
    } else {
      next.delete(source.filename);
    }
  });
  return next;
};

export const computeVisibleSelectionInfo = (
  filteredSources: Source[],
  selectedFiles: Set<string>,
): VisibleSelectionInfo => {
  const visibleCount = filteredSources.length;
  let selectedVisibleCount = 0;

  filteredSources.forEach((source) => {
    if (selectedFiles.has(source.filename)) {
      selectedVisibleCount += 1;
    }
  });

  return {
    visibleCount,
    selectedVisibleCount,
    allSelected: visibleCount > 0 && selectedVisibleCount === visibleCount,
    partiallySelected:
      selectedVisibleCount > 0 && selectedVisibleCount < visibleCount,
  };
};

export const deriveHeaderCheckboxState = (
  info: VisibleSelectionInfo,
): CheckedState => {
  if (info.visibleCount === 0) {
    return false;
  }
  if (info.allSelected) {
    return true;
  }
  if (info.partiallySelected) {
    return 'indeterminate';
  }
  return false;
};
